module.exports = __webpack_public_path__ + "media/customizations/regencyatstonebrook/back-87ac297a60ef022c8b5edbd1d3996412.jpg";